@layer base-components {
    .viewTableCell {
        max-width: 100%;
        display: inline-block;
    }
}
